import { render, staticRenderFns } from "./CustomerInvoice.vue?vue&type=template&id=2a8f151c&scoped=true&"
import script from "./CustomerInvoice.vue?vue&type=script&lang=js&"
export * from "./CustomerInvoice.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2a8f151c",
  null
  
)

export default component.exports